export default __webpack_public_path__ + "static/ie.75bfaf7a9258cfab912659f1082a80a2.png";